<template>
  <div width="70%" style="margin-bottom: 100px">
    <span>
      <el-form
        :label-position="'top'"
        :model="allowlistForm"
        :rules="allowlistForm.rules"
        label-width="110px"
        ref="allowlistFormRef"
      >
        <h3 class="left-text bold mb-25 h3-class-head" v-if="activeStep === 0">Create a New Allowlist Exception</h3>
        <h3 class="left-text bold mb-25 h3-class-head" v-else-if="activeStep === 1">Detection Type</h3>
        <h3 class="left-text bold mb-25 h3-class-head" v-else-if="activeStep === 2">Conditions Builder</h3>
        <h3 class="left-text bold mb-25 h3-class-head" v-else-if="activeStep === 3">Verify Before Submitting</h3>

        <el-steps
         :active="activeStep"
         process-status="success"
         finish-status="success"
         style="padding-left: 0%; padding-right: 44.23%; margin-bottom: 4%"
         v-if="activeStep < 3"
        >
          <el-step v-for="idx in numofsteps" :key="idx"></el-step>
        </el-steps>

        <div class="allowlist_name_desc" v-if="activeStep === 0">
          <el-row :type="'flex'" :gutter="8" class="mt-20">
            <el-col style="width:350px;">
              <el-row :gutter="20">
                <el-col :span="8" class="detection-block">
                  <span>
                    <p>
                      <b>Detection</b>
                      <br />
                      <span>{{ selectedDetectionAllowlist.iocSummary }}</span>
                    </p>
                    <p>
                      <b>Rule</b>
                      <br />
                      <span class="display-block" v-for="(selrule, idx) in selectedRulesDropdown" :key="idx">{{
                    selrule.name
                  }}</span>
                    </p>
                    <p>
                      <b>Security implications</b>
                      <br />
                      Scanning identifies live hosts, ports, and services, discovering Operating system and architecture
                      of target system, identifying vulnerabilities and threats in the network. Network scanning is used
                      to create a profile of the target organization.
                    </p>
                    <span class="text-btn" @click="loadDocumentation('page-allowlist')">Learn More</span>
                  </span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8" style="margin-top: 12px; font-weight: 600">
              <span class="allowlist_name">
                <el-form-item class="styled" label="Name of your allowlist exception" prop="model.name">
                      <el-input v-model="allowlistForm.model.name" class="input-width"></el-input>
                </el-form-item>
              </span>
              <span class="allowlist_desc">
                <el-form-item
                  class="styled"
                  label="Why would you like to allow this type of event?"
                  prop="model.description"
                >
                  <el-input
                  v-model="allowlistForm.model.description" 
                  type="textarea" 
                  :rows="6" 
                  class="input-width-innerarea"
                  ></el-input>
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <div class="footer-buttons text-center mt-90">
            <el-button class="float-right next" style="width: 144px" size="medium" @click="nextStep">Next</el-button>
          </div>
        </div>

        <div class="allowlist_name_desc" v-if="activeStep === 1">
          <span>
            <p>
              Select a type of detection you want to allow.
            </p>
          </span>
          <span>
            <el-form-item class="styled text-left detection-type" prop="model.allowListType">
              <el-radio-group v-model="allowlistForm.model.allowListType">
                <el-radio label="program"><span style="font-size:15px;">Program</span></el-radio>
                <el-radio label="network"><span style="font-size:15px;">Network</span></el-radio>
                <el-radio label="file"><span style="font-size:15px;">File</span></el-radio>
                <el-radio label="custom"><span style="font-size:15px;">Custom</span></el-radio>
              </el-radio-group>
            </el-form-item>
          </span>
          <div class="footer-buttons" style="margin-top: 210px">
            <el-button
              class="float-right next"
              size="medium"
              @click="nextStep"
              >Conditions Builder</el-button
            >
            <el-button class="white-back" size="medium" @click="prevStep">Back</el-button>
          </div>
        </div>

        <div class="conditions-builder-section" v-if="activeStep === 2">
          <div v-if="allowlistForm.model.conditions.length > 0">
            <p>Confirm or edit pre-filled conditions</p>
            <el-row :type="'flex'" :gutter="2">
              <el-col :span="7" style="margin-right: 2.3%">
                <label class="el-form-item__label bold">Attribute</label>
              </el-col>
              <el-col :span="7" style="margin-right: 2.3%">
                <label class="el-form-item__label bold">Operator</label>
              </el-col>
              <el-col :span="7">
                <label class="el-form-item__label bold">Value(one or more)</label>
              </el-col>
              <el-col :span="3" style="padding-left: 3.5%">
                <label class="el-form-item__label bold">Delete</label>
              </el-col>
            </el-row>
          </div>
          <div style="margin-bottom: 140px;">
            <el-form-item class="form-input-section styled"> 
              <el-row
                :type="'flex'"
                :gutter="2"
                v-for="(condition, index) in allowlistForm.model.conditions"
                :key="index"
                class="mb-16"
              >
                <el-col :span="7" style="margin-right: 2.3%">
                  <el-form-item
                    class="styled"
                    :prop="'model.conditions.' + index + '.attribute'"
                      :rules="{ required: true, message: 'attribute can not empty', trigger: 'change' }"
                  >
                    <el-select
                      v-model="condition.attribute"
                      value-key="id"
                      placeholder="Select"
                      @change="getConditionAttrValues"
                      class="dropdown-border"
                    >
                      <el-option-group v-for="group in allowlistFieldsGroup" :key="group.label" :label="group.label">
                        <el-option
                          v-for="item in group.options"
                          :key="`${item.level}_${item.value}`"
                          :label="item.label"
                          :value="item"
                        >
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7" style="margin-right: 2.3%">
                  <el-form-item
                    class="styled"
                    :prop="'model.conditions.' + index + '.operator'"
                    :rules="{ required: true, message: 'operator can not empty', trigger: 'change' }"
                  >
                    <el-select v-model="condition.operator" placeholder="Select" class="dropdown-border">
                      <el-option v-for="item in operators" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item
                    :prop="'model.conditions.' + index + '.values'"
                    :rules="{ type: 'array', required: true, message: 'Please select at least one value', trigger: 'change' }"
                  >
                    <el-select
                      class="dropdown-border"
                      v-model="condition.values"
                      filterable
                      allow-create
                      multiple
                      default-first-option
                      collapse-tags
                      style="styled"
                      placeholder="Select"
                      :key="loadingAttrKey"
                    >
                      <el-option
                        v-for="item in eventTypeValues[condition.attribute.eventTypeField]"
                        :key="item.value"
                        :label="item.value"
                        :value="item.value"
                        style="max-width:500px; overflow:ellipsis"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="3" style="padding-left: 4.5%">
                  <span class="material-icons cursor-pointer" @click="removeCondition(index)">
                    remove_circle_outline
                  </span>
                </el-col>
              </el-row>

              <div class="add-conditions">
                <span>Build conditions from scratch</span>
                <!-- <el-row :type="'flex'" :gutter="2">
                  <el-col :span="7" style="margin-right: 2.3%">
                    <el-form-item class="styled bold" label="Attribute">
                      <el-select
                        v-model="allowlistForm.model.condition.attribute"
                        value-key="id"
                        placeholder="Select"
                        @change="getConditionAttrValues"
                        class="dropdown-border"
                      >
                        <el-option-group v-for="group in allowlistFieldsGroup" :key="group.label" :label="group.label">
                          <el-option
                            v-for="item in group.options"
                            :key="`${item.level}_${item.value}`"
                            :label="item.label"
                            :value="item"
                          >
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" style="margin-right: 2.3%">
                    <el-form-item class="styled bold" label="Operator">
                      <el-select
                        v-model="allowlistForm.model.condition.operator"
                        placeholder="Select"
                        class="dropdown-border"
                      >
                        <el-option v-for="item in operators" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" style="margin-right: 2.5%">
                    <el-form-item class="styled bold" label="Value(one or more)" style="overflow: hidden">
                      <el-select
                        class="dropdown-border"
                        v-model="allowlistForm.model.condition.values"
                        filterable
                        allow-create
                        default-first-option
                        multiple
                        collapse-tags
                        style="styled"
                        placeholder="Select"
                        :key="loadingAttrKey"
                      >
                        <el-option
                          v-for="item in eventTypeValues[allowlistForm.model.condition.attribute.eventTypeField]"
                          :key="item.value"
                          :label="item.value"
                          :value="item.value"
                          style="max-width:500px; overflow:ellipsis"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 1%; margin-right: 0.5%">
                      <el-form-item class="styled bold" label="Delete">
                        <span
                          class="material-icons cursor-pointer reset-button"
                          style="margin-top: -37px; padding-left: 12%"
                          @click="resetCondition()"
                        >
                          remove_circle_outline
                        </span>
                      </el-form-item>
                    </el-col>
                </el-row> -->
                <br>
                <span
                  class="float-left material-icons cursor-pointer"
                  @click="addCondition(allowlistForm.model.condition)"
                >
                  add_circle_outline
                </span>
                <span>&nbsp;Add conditions</span>
              </div>
            </el-form-item>
          </div>
          <div class="footer-buttons mt-40" style="padding-bottom: 100px">
            <el-button class="float-right next" size="medium" @click="nextStep">Apply to Rule(s)</el-button>
            <el-button class="white-back" size="medium" @click="prevStep">Back</el-button>
          </div>
        </div>

        <div v-if="activeStep === 3" style="height: 72%; margin-top: 11.32%">
          <el-row :type="'flex'" :gutter="8" class="mt-20">
            <el-col>
              <el-row :gutter="20">
                <el-col :span="8" class="scanning-activity-block">
                  <span>
                    <b>Name: </b>
                      {{ allowlistForm.model.name }}
                  </span>
                    <br />
                    <br />
                  <span>
                    <b>Type: </b>
                      {{ allowlistForm.model.allowListType }}
                  </span>
                    <br />
                    <br />
                  <span>
                    <b>Rules: </b>
                    <br />
                    <span class="display-block" v-for="(selrule, idx) in selectedRulesDropdown" :key="idx">{{
                      selrule.name
                    }}</span>
                  </span>
                </el-col>

              <el-col :span="8" class="conditions-block">
                <div class="conditions-block-inner">
                  <div>
                      <b>Conditions</b>
                      <p v-for="(condition, index) in allowlistForm.model.conditions" :key="index" style="margin: 0px">
                        <span v-if="index !== 0 && condition.values.length">and</span>
                        <span v-if="condition.values.length">
                          {{ condition.attribute.level }} {{ condition.attribute.label }} {{ condition.operator }}
                          {{ condition.values }}
                        </span>
                      </p>
                  </div>
                  <div style="margin-top:10px;">
                    <b>Rules ({{ selectedRulesDropdown.length }} selected)</b>
                    <div style="overflow: auto">
                      <span class="display-block" v-for="(selrule, idx) in selectedRulesDropdown" :key="idx">{{
                        selrule.name
                      }}</span>
                    </div>
                    <div style="margin-top: 20px">
                      <el-button
                        type="text"
                        style="background: none; color: #409eff; margin-left: -26px"
                        @click="showAllRules = !showAllRules"
                      >
                        {{ showAllRules ? 'Hide' : 'See all selected rules' }}
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-col>
              </el-row>
            </el-col>
          </el-row>
          <div class="footer-buttons full-width mt-20">
            <el-button class="float-right" size="medium" @click="createAllowlist">Accept and Submit</el-button>
            <el-button class="white-back" size="medium" @click="prevStep">Back</el-button>
          </div>
        </div>
        <div v-if="activeStep === 4">
          <div class="mt-87">
            <div class="success-message">
              <h2>Success!</h2>
            </div>
            <div class="success-logo">
              <img style="height:69px; width:78px;" src="/static/images/success_logo.svg" alt="SUCCESS" />
            </div>
            <div class="exception-added-message" style="margin-top: 57.24px">
              Your allowed exception was added to the allowlist. Confluera helps you to have faster, more accurate investigations.
              <div style="font-weight: 550; margin-top: 20px">
                To add more, edit or delete your allowlist exceptions, go to:
              </div>
              <el-button size="medium" class="confluera-allowlist-button" @click="closeSuccess"
                >Confluera Allowlist</el-button
              >
            </div>
          </div>
        </div>
      </el-form>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { basicNameRe } from '@/utilities/regex/basic'

import { RULES_LIST_REQ, RULES_LIST_SUCCESS } from '@/store/modules/rules/rules.type'
import { MITRE_TACTIC_LIST_REQ, MITRE_TECHNIQUE_LIST_REQ } from '@/store/modules/mitre-attack/mitre-attack.type'

import CyberKillChainTickChart from '@/components/chart/CyberKillChainTickChart.vue'
import AllowlistForm from '@/components/form/allowlist/AllowlistForm.vue'

export default {
  name: 'AllowlistFormPrefill',
  extends: AllowlistForm,
  data() {
    return {
      activeStep: 0,
      numofsteps: 3,
      ruleCheckAll: false,
      ruleSearch: '',
      combineRules: [],
      allowlistForm: {
        error: '',
        model: {
          name: '',
          description: '',
          allowListType: 'custom',
          type: '',
          conditions: [],
          condition: {
            level: '',
            attribute: '',
            operator: '',
            values: ''
          },
          exemptRules: ''
        },
        rules: {
          model: {
            name: [
              {
                min: 1,
                max: 256,
                required: true,
                trigger: 'blur',
                validator: function (rule, value, callback) {
                  if (!value || !value.length) {
                    callback(new Error('Please provide the allowlist name'))
                  } else if (value.length > 256) {
                    callback(new Error('Allowlist name length exceeds 256'))
                  } else {
                    basicNameRe.test(value) ? callback() : callback(new Error('Invalid allowlist name format'))
                  }
                }
              }
            ],
            description: [
              {
                min: 1,
                max: 512,
                required: false,
                trigger: 'blur',
                validator: function (rule, value, callback) {
                  if (value.length > 512) {
                    callback(new Error('Allowlist description length exceeds 256'))
                  } else {
                    callback()
                  }
                }
              }
            ],
            type: [
              {
                required: true,
                trigger: 'blur',
                validator: function (rule, value, callback) {
                  if (!value || !value.length) {
                    callback(new Error('Please provide the allowlist type.'))
                  } else {
                    callback()
                  }
                }
              }
            ]
          }
        }
      }
    }
  },
  methods: {
    assignPrefillConditions() {
      // ProcessBinaryPath, ProcessName, ProcessCommandLine, parentProcessName, parentBinaryPath, artifactPath
      this.allowlistForm.model.name = `${this.selectedDetectionAllowlist.trailIdLabel} Rule ID ${this.selectedDetectionAllowlist.ruleid}`
      this.allowlistForm.model.description = `Allow list for ${this.selectedDetectionAllowlist.iocSummary}`
      _.assignIn(this.allowlistForm.model, {
        conditions: [
          {
            level: 'PARENT',
            attribute: this.getAttributeField('PARENT', 'BINARY'),
            operator: 'CONTAINS',
            values: [this.selectedDetectionAllowlist.iocEventsList[0].sourceBinaryName]
          },
          {
            level: 'PARENT',
            attribute: this.getAttributeField('PARENT', 'COMM'),
            operator: 'CONTAINS',
            values: [this.selectedDetectionAllowlist.iocEventsList[0].parentProcessName]
          },
          {
            level: 'PARENT',
            attribute: this.getAttributeField('PARENT', 'COMMAND_LINE'),
            operator: 'CONTAINS',
            values: [this.selectedDetectionAllowlist.iocEventsList[0].sourceCommandLine]
          },
          {
            level: 'CURRENT',
            attribute: this.getAttributeField('CURRENT', 'BINARY'),
            operator: 'CONTAINS',
            values: [this.selectedDetectionAllowlist.iocEventsList[0].sourceBinaryName]
          },
          {
            level: 'CURRENT',
            attribute: this.getAttributeField('CURRENT', 'COMM'),
            operator: 'CONTAINS',
            values: [this.selectedDetectionAllowlist.iocEventsList[0].sourceProcessName]
          },
          {
            level: 'CURRENT',
            attribute: this.getAttributeField('CURRENT', 'COMMAND_LINE'),
            operator: 'CONTAINS',
            values: [this.selectedDetectionAllowlist.iocEventsList[0].sourceCommandLine]
          }
        ]
      })

      if (!_.isEmpty(this.selectedDetectionAllowlist.iocEventsList[0].artifactPath)) {
        this.allowlistForm.model.conditions.push({
          level: 'CURRENT',
          attribute: this.getAttributeField('CURRENT', 'ARTIFACT'),
          operator: 'CONTAINS',
          values: [this.selectedDetectionAllowlist.iocEventsList[0].artifactPath]
        })
      }

      this.checkRule(this.selectedDetectionAllowlist.ruleid, true)
    }
  },
  created() {
    if (this.rulesListReqStatus !== 'saved') {
      Promise.all([this.$store.dispatch(MITRE_TACTIC_LIST_REQ), this.$store.dispatch(MITRE_TECHNIQUE_LIST_REQ)]).then(
        values => {
          this.$store.dispatch(RULES_LIST_REQ).then(rules => {
            this.$store.dispatch(RULES_LIST_SUCCESS)
            this.combineRules = _.cloneDeep(this.allRulesList).sort((a, b) => {
              a.showDetails = false
              a.display = true
              b.showDetails = false
              b.display = true
              return parseInt(a.id) - parseInt(b.id)
            })
            this.assignPrefillConditions()
          })
        }
      )
    } else {
      this.combineRules = _.cloneDeep(this.allRulesList).sort((a, b) => {
        a.showDetails = false
        a.display = true
        b.showDetails = false
        b.display = true
        return parseInt(a.id) - parseInt(b.id)
      })
      this.assignPrefillConditions()
    }
  },
  computed: {
    ...mapGetters([
      'userProfile',
      'rulesListReqStatus',
      'rulesList',
      'privilegedRulesList',
      'allRulesList',
      'selectedDetectionAllowlist'
    ])
  },
  components: {
    CyberKillChainTickChart,
    AllowlistForm
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
.error {
  text-align: center;
  color: var(--text-color-danger);
}

.el-dialog__wrapper {
  overflow: unset;
}

.el-dialog__wrapper >>> .el-dialog__body {
  overflow: auto;
  height: inherit;
}

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    span {
      color: white;
      margin-bottom: 6px;
    }
  }
}

.material-icons {
  font-size: 1.3em;
  line-height: 36px;
  vertical-align: middle;
  color: var(--gray-500);
  background: transparent;
}

>>> .el-dialog__body {
  .el-select {
    width: 100%;
  }

  .el-dropdown {
    width: 100%;
    box-sizing: border-box;
    background-color: white;
    background-image: none;
    border: none;

    .el-select {
      color: var(--border-color);
      border: 1px solid var(--border-color);
      opacity: 0.8;
      height: 40px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 660px;

      &:focus,
      &.focusing {
        border-color: #409eff;
        outline: 0;
      }

      > span {
        padding-left: 10px;
      }
      > i {
        padding-right: 10px;
      }
    }

    .el-icon-arrow-down {
      vertical-align: bottom;
      line-height: 40px;
      margin-right: 24px;
    }
  }
}

.icon-arrow-down {
  mask-repeat: no-repeat;
  mask-size: cover;
  vertical-align: middle;
  line-height: 36px;
  height: 14px;
  width: 14px;
  margin-top: 10px;
}

.el-dropdown-link .material-icons {
  line-height: 40px;
}

.el-dropdown_footer {
  padding: 20px 20px 10px;
  border: 1px solid transparent;

  .material-icons {
    line-height: 26px;
    border: 1px solid var(--border-color);
  }

  .el-col {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 500px;
  }
}

.el-divider--vertical {
  margin: 0px;
}

.search-select-dropdown {
  >>> .el-input__inner {
    border-radius: 0px;
  }

.search-width{
  border: 1px solid #C6CBD2;
  transform: scaleX(1);
  border-radius: 2px;
  height: 32px;
}

.search-dropdown-width{
  border: 1px solid #f9fafc;
  border-radius: 1px;
  height: 32px;
}

  >>> .el-dropdown-menu__item {
    padding: 0px;
    padding-top: 0px;
    padding-bottom: 0px;

    > div {
      border: 1px solid var(--border-color);
      border-top: 0px;
      border-left: 0px;
      border-right: 0px;
    }

    &:hover {
      background-color: #f5f7fa;
      color: inherit;
    }

    &.row-selected {
      background: var(--denim-50) !important;
    }

    > span {
      vertical-align: middle;
    }

    .description {
      max-width: 600px;
      word-break: break-word;
      line-height: 20px;
    }

    .el-row {
      padding: 0px 20px;

      &.row-drawer {
        background: white;
      }
    }

    .el-col-19 {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

.row-border {
  border: 1px solid var(--border-color);

  &.list-row {
    border-bottom: 0px;
  }
}

>>> .el-step__head.is-success {
  color: #1A90FA;
}


>>> .el-step__head {
  fill: #1A90FA;
  border-color: #1A90FA;
}

>>> .el-step__line{
  background-color: #1A90FA;
}

>>> .el-form {
  height: 90%;
}

.conditions-builder-section {
  height: inherit;
}

.form-input-section {
  height: 60%;
}

.el-form-item:not(.is-error) {
  .custom-value-input {
    >>> .el-input__inner,
    >>> .el-textarea__inner {
      font-family: var(--main-font-family);
      border: 1px solid var(--border-color);
      border-radius: 0px;
      word-break: keep-all;
    }
  }
}

.el-form-item.is-error {
  .custom-value-input {
    >>> .el-input__inner,
    >>> .el-textarea__inner {
      font-family: var(--main-font-family);
      border-radius: 0px;
      word-break: keep-all;
    }
  }
}
.clear-input {
  cursor: pointer;
  margin-left: 8px;
}

.list-row {
  >>> .el-input__inner {
    border: none;
  }
}

>>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  background-color: var(--gray-50);
  border-bottom: 1px solid var(--border-color);
  padding-left: 15px;
  font-size: 10px;
  font-weight: normal;
  color: inherit;
  line-height: 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

>>> .el-collapse-item__content {
  padding-top: 15px;
}

.input-width{
  height: 40px;
  width: 385px;
}

.input-width-innerarea{
  height: 110px;
  width: 385px;
}

>>> .el-input {
  line-height: 36px;

  .el-input__inner {
    height: 36px;
    line-height: inherit;
  }
}


>>> .el-form-item {
  margin-bottom: 10px;
}

>>> .el-form-item__label {
  max-height: 40px;
}

.grouped-form-label {
  >>> .el-form-item__label {
    line-height: 2em;
  }

  .el-form-item {
    display: inline-block;
    width: 20%;
  }
}

>>> .and-tag {
  padding: 4px;
}

>>> .el-steps {
  left: 5%;
  .el-step__icon-inner:not(.el-icon-check) {
    display: none;
  }
}

.allowlist_name_desc {
  .allowlist_name,
  .allowlist_desc {
    width: 48%;
    display: table;
    vertical-align: top;
  }

  >>> .el-form-item__label {
    height: 24px;
    line-height: 20px;
    font-size: 12px;
  }
}

.el-button {
  height: 36px;
  width: auto;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
  padding: 2px 25px 2px 25px;
}

.white-back{
  height: 36px;
  width: 112px;
  color: var(--aluminum-800);
  border: 1px solid var(--aluminum-800);
  float: right;
  margin-right: 15px;
}

.footer-buttons {
  .float-right{
    height: 36px;
    width: auto;
    border-radius: 4px;
    background-color: #1A90FA;
  }
}

.next{
  bottom: 22.26%;
  right: 22.36%;
}

.h3-class-head{
  height: 29px;
  width: 403px;
  color: #454B60;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 26px;
}

.reset-button {
  vertical-align: bottom;
  margin-top: 40px;
}

.box-outline {
  border: 1px solid transparent;
  padding: 8px;
}

textarea {
  font-family: 'Muli', sans-serif;
}

.selected-options {
  border: 1px solid black;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  height: -webkit-fill-available;
  margin: 1px 0 1px 0;
  width: 98%;
}

.dropdown-border{
  border: 1px solid #A1A8AE;
  border-radius: 2px;
}

.detection-block{
  display: inline-block;
  width: 90%;
  height:27.34%;
  line-height: 20px;
  letter-spacing: 0.09px;
  font-size: 13px;
  font-weight:500;
}

.selected-rules-footer{
  padding-left: 17px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
}

.scanning-activity-block{
  display: inline-block;
  width: 37.10%;
  height:29.29%;
  line-height: 20px;
  letter-spacing: 0;
  font-size: 15px;
  color: #454B60;
}

.conditions-block{
  margin-left: 0px;
  display: flex;
  overflow: hidden auto;
  width: 43.16%;
  height: 327px;
  background-color: #FFFDE5;
  border-radius: 2px;
}

.conditions-block-inner{
  display: inline-block;
  width: 380px;
  height: 230.8px;
  color: #454B60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 20px;
  margin-left: 29px;
  margin-right: 33px;
  margin-top: 31.2px;
  margin-bottom: 65px
}

.confluera-allowlist-button{
  border-radius: 4px;
  background-color: #1A90FA;
  margin-top: 30px;
}

.detection-type{
  margin-top: 52px;
}

.security-search{
  height: 346px;
  width: 362px;
  margin-right: 6.15%;
}

.security-rules-conditions{
  height: 140px;
  width: 380px;
  color: #454B60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 20px;
}

.success-message{
    height: 29px;
    width: 104px;
    color: #454B60;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 26px;
    margin: auto;
}

.exception-added-message{
  height: 90px;
  color: #454B60;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  margin-left: 110px;
  width: 65%;
  margin: 0 auto;
}

.arrow-tooltip{
  width:500px;
  max-height:350px;
  overflow:auto;
  display: flex;
  justify-content: space-between;
}

.success-logo{
  display: flex;
  justify-content: center;
  margin-top: 61px;
}

.text-btn {
  cursor: pointer;
  color: #409eff;
}

>>> .el-select__tags .el-select__tags-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90px;
  display: inline-block;
  vertical-align: middle;
}

>>> .el-scrollbar__wrap{
  width: 500px;
  overflow: scroll;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/form/allowlist/AllowlistFormPrefill.vue